import DuckEntity from './DuckEntity';

const entity = new DuckEntity('orderTransactions');
const reducer = entity.reducer;
export {reducer as default, entity};
